import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";

import { PaginationComponent } from "./PaginationComponent";
import { Collapse } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { ROW_PER_PAGE } from "../../routes";

export default function CardTable({ color, title, columns, rows, keys, infoTitle, rowCount, icon }) {

  const { t } = useTranslation('global');
  const [projectInfo, setProjectInfo] = useState({});
  const [showProjectInfo, setShowProjectInfo] = useState(false);
  const [proyectos, setProyectos] = useState([]);

  const [rowsToShow, setRowsToShow] = useState([]);
  const [active, setActive] = useState(1);
  const rowPerPage = ROW_PER_PAGE;
  const totalPages = Math.ceil(rowCount / rowPerPage);
  const [leftIndex, setLeftIndex] = useState(0);
  const [rightIndex, setRightIndex] = useState(rowPerPage);
  
  const projectInfoRef = useRef(null);

  const next = () => {
    if (active === totalPages) return;

    if (rowCount < rightIndex + rowPerPage + 1) {
      setRowsToShow(proyectos.slice(rightIndex, rowCount));
      setRightIndex(rowCount);
    } else {      
      setRowsToShow(proyectos.slice(rightIndex, rightIndex + rowPerPage));
      setRightIndex(rightIndex + rowPerPage);
    }    
    setLeftIndex(rightIndex);
    
    setActive(active + 1);
  };
 
  const prev = () => {
    if (active === 1) return;

    setRowsToShow(proyectos.slice(leftIndex - rowPerPage, leftIndex));

    setLeftIndex(leftIndex - rowPerPage);
    setRightIndex(leftIndex);

    setActive(active - 1);
  };

  const getProjectInfo = (currentProject) => {
    const lastProject = projectInfo;
      setProjectInfo(currentProject);

      if (Object.keys(lastProject).length === 0) {
        setShowProjectInfo((showProjectInfo) => !showProjectInfo);
      }

      if (Object.keys(lastProject).length !== 0 && ((lastProject['id'] === currentProject.id) || (lastProject['id'] !== currentProject.id && !showProjectInfo))) {
        setShowProjectInfo((showProjectInfo) => !showProjectInfo);
      }        

      setTimeout(function () {
        projectInfoRef.current.scrollIntoView({
            behavior: "smooth",
            block: 'center', inline: 'center' 
        });
      }, 200);
  }

  const closeProjectInfo = () => {
    setShowProjectInfo(false);
    setProjectInfo({});
    setTimeout(function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 170);
  }

  useEffect(() => {
    if (rowCount < rightIndex) {
      setRowsToShow(rows.slice(leftIndex, rowCount));
    } else {
      setRowsToShow(rows.slice(leftIndex, rightIndex))
    }
    setProyectos(rows);
  },[rowCount, rightIndex, rows, leftIndex])
  
  return (
    <div className="flex flex-col w-full">
      <div className="rounded-t mb-0 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="w-full mb-2 max-w-full flex flex-row items-center">
              <div className="text-white mr-4 p-3 text-center inline-flex items-center justify-center w-16 h-16 shadow-lg rounded-full bg-blueGray-700">
                <FontAwesomeIcon icon={icon} />
              </div>
              <h3
                className="md:text-2xl text-3xl font-semibold leading-normal"
              >
                {title}
              </h3>
            </div>
          </div>
        </div>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-blueGray-700 text-white")
        }
      >
        <div className="block w-full overflow-x-auto">
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                {
                  columns.map((col) => {
                    return (
                      <th
                        key={col.id}
                        className={
                          "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0  font-semibold text-left bg-blueGray-700 text-white border-blueGray-700"
                        }
                      >
                        {
                          col.id !== 'url' && <p className="min-w-140-px break-words">{col.label}</p>
                        }
                      </th>
                    )
                  })
                }
              </tr>
            </thead>
            <tbody>
                {
                  rowsToShow.map((row, index) => {
                    return (
                      <tr key={index}>
                        {
                          columns.map((column) => {
                            
                            let parts = ''
                            if (column.id === 'pub' && row[column.id].includes('*')) {
                              parts = row[column.id].trim().split('*');
                            }

                            return (
                              <td key={row.id + column.id} className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm p-4">
                                <p className="min-w-140-px break-words">
                                {
                                  column.id !== 'more' & column.id !== 'url' & column.id !== 'link_eva' & column.id !== 'link_curso_fing'
                                ?
                                  column.id === 'pub' && row[column.id].includes('*') 
                                  ? 
                                    <>{parts[0]}<i>{parts[1]}</i>{parts[2]}</> 
                                  : 
                                    row[column.id]
                                :
                                column.id === 'url' || column.id === 'link_eva' || column.id === 'link_curso_fing' 
                                ?
                                  row[column.id] !== '' ? 
                                  <a href={row[column.id]} className="underline" target="_blank" rel="noopener noreferrer">
                                    {column.label}
                                  </a>
                                  :
                                  <p></p>
                                : // column.id == 'more'
                                <button
                                  className="text-blueGray-600 border-blueGray-600 border-solid-radius py-2 px-4 uppercase bg-white font-semibold active:bg-blueGray-200"
                                  onClick={() => {
                                      getProjectInfo(row);
                                    }
                                  }
                                >
                                  {t('Research.more_info')}
                                </button>
                                }
                                </p>
                              </td>
                            )                       
                            
                          })
                        }                        
                      </tr>
                    )
                  })
                }
            </tbody>
          </table>
        </div>
        <div className="flex my-6 justify-center">
          {
            rowCount !== 0 ?
            <PaginationComponent 
            nextPage={next}
            prevPage={prev}
            active={active}
            totalPages={totalPages}
            pageName={t('Research.page')}
            />
            :
            <p>{t('Research.no_projects')}</p>
          }
          
        </div>
      </div>
      {
        keys !== undefined &&
        <section ref={projectInfoRef}>
          <Collapse  open={showProjectInfo}>
            {
              Object.keys(projectInfo).length !== 0 &&

              <div className="p-4 relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}} className="relative w-full px-6 py-4 max-w-full flex-grow flex-1 bg-blueGray-700 text-white border-blueGray-700">
                    <h3
                      className={
                        "font-semibold text-lg bg-blueGray-700 font-semibold"
                      }
                    >
                      {infoTitle}
                    </h3>
                    <button
                      onClick={closeProjectInfo}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                <div className="px-6">
                  {
                    keys.map((key) => {
                      if (key.id === 'descripcion') {
                        var count = 0;
                        const descripcion = projectInfo[key.id].replace(/\\n/g, '\n').split('\n').map(str => <><p key={key.id + count++}>{str}</p><br/></>);
                        return descripcion;
                      } else {
                        return (
                          <div key={key.id} className="flex flex-row w-full my-2">
                            <h3 className="text-blueGray-700 font-semibold font-xs" key={key.id}>{key.label + ":"}</h3>
                            <p className="ml-2">{projectInfo[key.id]}</p>
                          </div>
                        )
                      }
                    })
                  }
                </div>
              </div>
            }
          </Collapse>
        </section>
      }
    </div>
  );
}

CardTable.defaultProps = {
  color: "light",
};

CardTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
